// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.6 5.1C3.6 4.27 4.27 3.6 5.1 3.6C5.93 3.6 6.6 4.27 6.6 5.1V10.9C6.6 11.73 5.93 12.4 5.1 12.4C4.27 12.4 3.6 11.73 3.6 10.9V5.1Z',
  'M9.4 5.1C9.4 4.27 10.07 3.6 10.9 3.6C11.73 3.6 12.4 4.27 12.4 5.1V10.9C12.4 11.73 11.73 12.4 10.9 12.4C10.07 12.4 9.4 11.73 9.4 10.9V5.1Z',
];
